import userDataAPI from '../../APIs/LoginAPI/UserDataAPI'

export const getUtil = {
    state: {
        utilization: null,
        noutil: null
    
    },
    actions: {
        displayUtil({ commit }, userMembn) {
            userDataAPI.userUtil(userMembn).then((res) => {
                commit('DISPLAY_UTIL', res.data)
            })
        }
    },
    mutations: {
        DISPLAY_UTIL(state, utilization) {
            state.utilization = utilization
        },
        NO_UTIL(state, noutil) {
            state.noutil = noutil
        }
    },
    getters: {
        getUtil(state) {
            return state.utilization
        },
        NoUtil(state) {
            return state.noutil
        }
    }
}
